import { Type } from '@sinclair/typebox';
export const ProductSystemVersionResponseSchema = Type.Object({
    id: Type.Number(),
    description: Type.String(),
    active: Type.Boolean(),
});
export const CreateProductSystemVersionSchema = Type.Omit(ProductSystemVersionResponseSchema, ['id', 'active']);
export const UpdateProductSystemVersionSchema = Type.Partial(Type.Omit(ProductSystemVersionResponseSchema, ['id']));
//# sourceMappingURL=product-system-versions.js.map